import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { GenericListProps } from "../../types/GenericListType";
import { List } from "../../components/List";
import { GroupedComponents } from "../../components/GroupedComponents";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";

export interface StreetlightFaultsPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  wantToReport?: GreyCardProps;
  faqs?: FaqAccordionGroupProps;
}

export const StreetlightFaultsPage: React.FC<StreetlightFaultsPageProps> = ({ seo, pageTitle, paragraphs, lists, wantToReport, faqs }) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      {wantToReport && <GreyCard {...wantToReport} />}
    </ServiceCataloguePageWrapper>
  );
};
